var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{staticStyle:{"width":"280px","height":"280px"},attrs:{"id":"QRCode_header"}})])
}]

export { render, staticRenderFns }